import React from "react";

import { LoginRedirect } from "./LoginRedirect";
import { SigninCallback } from "./SigninCallback";

interface AuthPageProps {
    isInitializedUserManager: boolean;
    isLoggedIn: boolean;
    callback(): void;
    login(): void;
}

export const AuthPage: React.VFC<AuthPageProps> = ({
    isInitializedUserManager,
    isLoggedIn,
    callback,
    login
}: AuthPageProps) => {
    const isCallback = window.location.href.includes("signin-callback");

    if (!isInitializedUserManager) {
        return null;
    }

    if (isCallback) {
        return <SigninCallback onCallback={callback} />;
    }

    if (!isLoggedIn) {
        return <LoginRedirect onLogin={login} />;
    }

    return null;
};
